import controller from './limit-exceeded.controller';
import '../student.less';

export default {
  controller,
  template: require('./limit-exceeded.html')
};



// WEBPACK FOOTER //
// src/app/components/student/limit-exceeded/limit-exceeded.component.ts